import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';
import PercentageChange from './percentage-change';
import Tag from './tag';
import { H4Atom } from '../../../atoms/text-atoms/text-atoms';
import SingleBar from '../../single-bar/single-bar';

const DataVisualisationCellContents = ({
  currentValue,
  displayCurrentValue,
  previousValue,
  target,
  displayTarget,
  showPercentageChange = true,
  isFirstYear,
  isDeviated,
  displayGraph = false,
  className,
}) => {
  return (
    <div className={className}>
      {showPercentageChange && (
        <PercentageChange
          currentValue={currentValue}
          previousValue={previousValue}
          isFirstYear={isFirstYear}
        />
      )}
      {displayCurrentValue && <H4Atom>{displayCurrentValue}</H4Atom>}
      {displayTarget && <H4Atom>{displayTarget}</H4Atom>}
      {displayGraph && <SingleBar target={target} value={currentValue} />}
      {isDeviated && <Tag colour={vars.deltaRed}>not aligned *</Tag>}
    </div>
  );
};

// === DataVisualisationCellContents CSS ===
const StyledDataVisualisationCellContents = styled(
  DataVisualisationCellContents
)`
  ${PercentageChange} {
    min-width: 13rem;
  }
  ${H4Atom} {
    font-weight: ${vars.fontWeightRegular};
    ${vars.fontSize2}
    padding: ${vars.spacingXs} 0;
  }
  ${Tag} {
    margin-top: ${vars.spacingS};
  }
`;

export default StyledDataVisualisationCellContents;
